import { ComponentStyleConfig } from '@chakra-ui/react';

const Button: ComponentStyleConfig = {
  defaultProps: {
    variant: 'primary',
  },
  baseStyle: {
    display: 'flex',
    fontWeight: '400',
    // rounded: "full",
    fontSize: '16px',
    _focus: {
      ring: '0px',
    },
  },
  sizes: {
    sm: {
      h: '30px',
      fontSize: '14px',
      px: '20px',
    },
    md: {
      h: '48px',
      fontSize: '16px',
      px: '24px',
    },
    lg: {
      h: '56px',
      fontSize: '18px',
      px: '28px',
    },
  },
  variants: {
    primary: {
      bg: 'btn-primary-bg',
      color: 'white',
      _hover: {
        bg: 'btn-primary-pressed-bg',
        _disabled: {
          bg: 'btn-disabled-bg',
          color: 'white',
        },
      },
      _disabled: {
        bg: 'btn-disabled-bg',
        color: 'white',
        opacity: 0.9,
      },
    },
    main: {
      bg: 'primary-color',
      color: 'white',
      _hover: {
        bg: 'grey.900',
      },
    },
    secondary: {
      bg: 'content-bg',
      color: 'text-primary-color',
      rounded: 'full',
      py: '.5em',
      px: '.75em',
      minW: 'unset',
      height: 'unset',
      _hover: {
        bg: 'grey.250',
      },
    },
    couter: {
      bg: 'unset',
      color: 'primary-color',
      _hover: {
        bg: 'grey.250',
      },
      _disabled: {
        bg: 'unset',
        opacity: '0.3',
      },
    },
    counter2: {
      bg: 'content-bg',
      width: '20px',
      height: '20px',
      minW: 'unset',
      color: 'primary-color',
      _hover: {
        bg: 'grey.250',
      },
      _disabled: {
        opacity: '0.4',
      },
    },
  },
};

export default Button;